<template>
    <div>
        <myHeader></myHeader>
        <div class="product_wrap">
            <div class="product">
                <div class="product_nav">
                    <div class="product_nav_ul">
                        <div class="product_nav_li" :class="{active:item.id==current}" @click="changNav(item.id)"
                             v-for="(item,index) in caseList" :key="index" v-show="item.type === 0">
                            <img src="../../static/images/chaoda_icon.png" alt="" v-show="item.title==='超大件货物'">
                            <span>{{item.title}}</span>
                        </div>
                    </div>
                    <div class="product_nav_ul">
                        <div class="product_nav_li" :class="{active:item.id==current}" @click="changNav(item.id)"
                             v-for="(item,index) in caseList" :key="index" v-show="item.type === 1">
                            <img src="../../static/images/puhuo_icon.png" alt="" v-show="item.title==='普货'">
                            <span>{{item.title}}</span>
                        </div>
                    </div>
                </div>
                <div class="product_details">
                    <div class="product_details_title" v-if="current===9 || current===10">产品解决方案</div>
                    <div class="product_details_title" v-else>解决方案示例图</div>
                    <div class="product_details_nr" v-html="caseDetails"></div>
                </div>
            </div>
        </div>
        <myFooter></myFooter>
    </div>
</template>

<script>
import myHeader from '../components/header.vue'
import MyFooter from '../components/footer.vue'
export default {
    name: 'product_case',
    components: {MyFooter, myHeader},
    data () {
        return {
            id:9,
            caseList:[],
            caseDetails:{},
            current:9,
        }
    },
    created () {
        this.id = this.$route.query.id;
        if(this.id === undefined){
            this.id = 9;
            this.changNav(9);
        }else{
            this.changNav(this.id);
        }
        this.pageData();
    },
    methods: {
        pageData(){
            this.$api.solutionList().then(res => {
                this.caseList = res.data;
            });
        },
        pageDetail(){
            let params = {
                id:this.current
            };
            this.$api.solutionDetail(params).then(res => {
                this.caseDetails = res.data;
            });
        },
        changNav(id){
            this.current = id;
            this.pageDetail();
        }
    }
}
</script>


<style scoped>
.product_wrap{width:100%;height:600px;display:block;float:left;background:url(../../static/images/product_bg.jpg) center no-repeat;
    background-size:1920px 600px;}
.product{width:960px;height:600px;background:#222;float:left;position:relative;left:50%;margin-left:-480px;}
.product_nav{width:250px;height:600px;display:inline-block;float:left;background:#293f53;}
.product_nav_ul{width:100%;height:300px;display:block;float:left;}
.product_nav_ul .product_nav_li:first-child{width:100%;height:96px;float:left;padding:23px 70px;position:relative;background:#333;cursor:pointer;}
.product_nav_ul .product_nav_li:first-child span{width:100%;height:50px;font-size:17px;color:#fff;line-height:50px;display:block;overflow:hidden;font-weight:bold;}
.product_nav_ul .product_nav_li:first-child img{width:30px;height:30px;display:block;position:absolute;left:25px;top:50%;margin-top:-15px;z-index:2;}
.product_nav_ul .product_nav_li:first-child.active{background:#0a64ba;}
.product_nav_ul .product_nav_li:first-child.active span{color:#fff;}
.product_nav_ul .product_nav_li:nth-child(6){width:100%;height:96px;float:left;padding:23px 70px;position:relative;background:#333;cursor:pointer;}
.product_nav_ul .product_nav_li:nth-child(6) span{width:100%;height:50px;font-size:17px;color:#fff;line-height:50px;display:block;overflow:hidden;font-weight:bold;}
.product_nav_ul .product_nav_li:nth-child(6) img{width:30px;height:30px;display:block;position:absolute;left:25px;top:50%;margin-top:-15px;z-index:2;}
.product_nav_ul .product_nav_li:nth-child(6).active{background:#0a64ba;}
.product_nav_ul .product_nav_li:nth-child(6).active span{color:#fff;}
.product_nav_ul .product_nav_li{width:100%;padding:0 70px;border-bottom:1px solid #333;cursor:pointer;}
.product_nav_ul .product_nav_li:last-child{border-color:#333;}
.product_nav_ul .product_nav_li span{width:100%;height:50px;font-size:14px;color:#fff;line-height:50px;display:block;overflow:hidden;}
.product_nav_ul .product_nav_li.active{background:#0a64ba;}
.product_nav_ul .product_nav_li.active span{color:#fff;}
.product_details{width:710px;height:600px;float:left;padding:30px 40px;overflow:hidden;}
.product_details_title{width:100%;height:30px;float:left;font-size:16px;color:#ffc000;line-height:30px;overflow:hidden;}
.product_details_nr{width:100%;height:495px;float:left;font-size:14px;color:#fff;line-height:24px;display:block;
    margin-top:15px;overflow:hidden;overflow-y:scroll;}
.product_details_nr::-webkit-scrollbar {width:0;height:0;}
.product_details_nr::-webkit-scrollbar-thumb {
    background: transparent;
}
.product_details_nr::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background: transparent;
}
.product_details_nr img{max-width:100%;height:auto;display:block;margin-bottom:10px;}
@media (min-width:992px) and (max-width:1200px){
    .product_wrap{height:600px;background:url(../../static/images/product_bg.jpg) center no-repeat;
        background-size:1920px 600px;}
    .product{width:800px;height:600px;margin-left:-400px;}
    .product_nav{width:250px;height:600px;display:inline-block;float:left;background:#293f53;}
    .product_nav_ul{width:100%;height:300px;display:block;float:left;}
    .product_nav_ul .product_nav_li:first-child{height:96px;float:left;padding:23px 70px;position:relative;background:#333;cursor:pointer;}
    .product_nav_ul .product_nav_li:first-child span{width:100%;height:50px;font-size:17px;color:#fff;line-height:50px;display:block;overflow:hidden;font-weight:bold;}
    .product_nav_ul .product_nav_li:first-child img{width:30px;height:30px;display:block;position:absolute;left:25px;top:50%;margin-top:-15px;z-index:2;}
    .product_nav_ul .product_nav_li:nth-child(6){width:100%;height:96px;float:left;padding:23px 70px;position:relative;background:#333;cursor:pointer;}
    .product_nav_ul .product_nav_li:nth-child(6) span{width:100%;height:50px;font-size:17px;color:#fff;line-height:50px;display:block;overflow:hidden;font-weight:bold;}
    .product_nav_ul .product_nav_li:nth-child(6) img{width:30px;height:30px;display:block;position:absolute;left:25px;top:50%;margin-top:-15px;z-index:2;}
    .product_nav_ul .product_nav_li:nth-child(6).active{background:#0a64ba;}
    .product_nav_ul .product_nav_li:nth-child(6).active span{color:#fff;}
    .product_nav_ul .product_nav_li{width:100%;padding:0 70px;border-bottom:1px solid #333;cursor:pointer;}
    .product_nav_ul .product_nav_li:last-child{border-color:#333;}
    .product_nav_ul .product_nav_li span{width:100%;height:50px;font-size:14px;color:#fff;line-height:50px;display:block;overflow:hidden;}
    .product_details{width:550px;height:600px;float:left;padding:30px 40px;overflow:hidden;}
    .product_details_title{width:100%;height:30px;float:left;font-size:16px;color:#ffc000;line-height:30px;overflow:hidden;}
    .product_details_nr{width:100%;height:495px;float:left;font-size:14px;color:#fff;line-height:24px;display:block;
        margin-top:15px;overflow:hidden;overflow-y:scroll;}
    .product_details_nr img{max-width:100%;height:auto;display:block;margin-bottom:10px;}
}
@media (min-width:768px) and (max-width:991px){
    .product_wrap{height:600px;background:url(../../static/images/product_bg.jpg) center no-repeat;
        background-size:1920px 600px;}
    .product{width:750px;height:600px;margin-left:-375px;}
    .product_nav{width:250px;height:600px;display:inline-block;float:left;background:#293f53;}
    .product_nav_ul{width:100%;height:300px;display:block;float:left;}
    .product_nav_ul .product_nav_li:first-child{height:96px;float:left;padding:23px 70px;position:relative;background:#333;cursor:pointer;}
    .product_nav_ul .product_nav_li:first-child span{width:100%;height:50px;font-size:17px;color:#fff;line-height:50px;display:block;overflow:hidden;font-weight:bold;}
    .product_nav_ul .product_nav_li:first-child img{width:30px;height:30px;display:block;position:absolute;left:25px;top:50%;margin-top:-15px;z-index:2;}
    .product_nav_ul .product_nav_li:nth-child(6){width:100%;height:96px;float:left;padding:23px 70px;position:relative;background:#333;cursor:pointer;}
    .product_nav_ul .product_nav_li:nth-child(6) span{width:100%;height:50px;font-size:17px;color:#fff;line-height:50px;display:block;overflow:hidden;font-weight:bold;}
    .product_nav_ul .product_nav_li:nth-child(6) img{width:30px;height:30px;display:block;position:absolute;left:25px;top:50%;margin-top:-15px;z-index:2;}
    .product_nav_ul .product_nav_li:nth-child(6).active{background:#0a64ba;}
    .product_nav_ul .product_nav_li:nth-child(6).active span{color:#fff;}
    .product_nav_ul .product_nav_li{width:100%;padding:0 70px;border-bottom:1px solid #333;cursor:pointer;}
    .product_nav_ul .product_nav_li:last-child{border-color:#333;}
    .product_nav_ul .product_nav_li span{width:100%;height:50px;font-size:14px;color:#fff;line-height:50px;display:block;overflow:hidden;}
    .product_details{width:500px;height:600px;float:left;padding:30px 40px;overflow:hidden;}
    .product_details_title{width:100%;height:30px;float:left;font-size:16px;color:#ffc000;line-height:30px;overflow:hidden;}
    .product_details_nr{width:100%;height:495px;float:left;font-size:14px;color:#fff;line-height:24px;display:block;
        margin-top:15px;overflow:hidden;overflow-y:scroll;}
    .product_details_nr img{max-width:100%;height:auto;display:block;margin-bottom:10px;}
}
@media (max-width:767px){
    .product_wrap{height:600px;background:#333;}
    .product{width:100%;height:600px;margin-left:0;left:0;}
    .product_nav{width:35%;height:600px;}
    .product_nav_ul{width:100%;height:300px;}
    .product_nav_ul .product_nav_li:first-child{height:96px;float:left;padding:23px 15px 23px 45px;position:relative;background:#333;cursor:pointer;}
    .product_nav_ul .product_nav_li:first-child span{width:100%;height:50px;font-size:15px;color:#fff;line-height:50px;display:block;overflow:hidden;font-weight:bold;}
    .product_nav_ul .product_nav_li:first-child img{width:20px;height:20px;display:block;position:absolute;left:15px;top:50%;margin-top:-10px;z-index:2;}
    .product_nav_ul .product_nav_li:nth-child(6){width:100%;height:96px;float:left;padding:23px 15px 23px 45px;position:relative;background:#333;cursor:pointer;}
    .product_nav_ul .product_nav_li:nth-child(6) span{width:100%;height:50px;font-size:15px;color:#fff;line-height:50px;display:block;overflow:hidden;font-weight:bold;}
    .product_nav_ul .product_nav_li:nth-child(6) img{width:20px;height:20px;display:block;position:absolute;left:15px;top:50%;margin-top:-10px;z-index:2;}
    .product_nav_ul .product_nav_li:nth-child(6).active{background:#0a64ba;}
    .product_nav_ul .product_nav_li:nth-child(6).active span{color:#fff;}
    .product_nav_ul .product_nav_li{width:100%;padding:0 15px;border-bottom:1px solid #333;cursor:pointer;}
    .product_nav_ul .product_nav_li:last-child{border-color:#333;}
    .product_nav_ul .product_nav_li span{width:100%;height:50px;font-size:14px;color:#fff;line-height:50px;display:block;overflow:hidden;}
    .product_details{width:65%;height:600px;float:left;padding:10px 15px;overflow:hidden;}
    .product_details_title{width:100%;height:30px;float:left;font-size:16px;color:#ffc000;line-height:30px;overflow:hidden;}
    .product_details_nr{width:100%;height:515px;float:left;font-size:12px;color:#fff;line-height:20px;display:block;
        margin-top:15px;overflow:hidden;overflow-y:scroll;}
    .product_details_nr img{max-width:100%;height:auto;display:block;margin-bottom:10px;}
}
</style>



// WEBPACK FOOTER //
// src/pages/product_case.vue